import { useEffect } from "react";
import { Accordion } from 'react-light-accordion';
import MessageEmptyData from "../../../common/messageEmptyData";
import ShiftReportAccordion from './shiftReportAccordion';
import * as Shared from "../../../common/shared";

const DISCIPLINE_KEY_TO_READABLE = {
    rcx: 'RCX',
    rotary: 'Rotary',
    surface_core: 'Surface Core',
    underground_core: 'Underground',
    summary: 'General Summary',
}

/**
 * Body component for ShiftReport Report
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const ShiftReportBody = (prop) => {
    const { filters, data } = prop;

    useEffect(() => {
        Shared.toggleAllAccordionItems();
    }, [data])

    if (!filters.isSubmitted) {
        return null;
    }

    if (data === null) {
        return <MessageEmptyData />;
    }

    return (
        <div className="container-fluid card-body">
            <div className="default-according panel-accordion" id="accordionclose">
                <Accordion atomic="false">
                    {Object.keys(data).map(disciplineKey => {
                        return <ShiftReportAccordion 
                            key={disciplineKey} 
                            title={DISCIPLINE_KEY_TO_READABLE[disciplineKey]} 
                            data={data[disciplineKey]} 
                        />
                    })}
                </Accordion>
            </div>
        </div>
    );
}

export default ShiftReportBody;
